import { createAction, props } from '@ngrx/store';
import { Promotion } from '@app/shared/models/promotion';

// Load users promotion
export const loadPromotion = createAction(
  '[Promotion] Load Promotion',
  props<{ promotionId: string, teamId?: string }>()
);

export const loadPromotionSuccess = createAction(
  '[Promotion] Load Promotion Success',
  props<{ promotion: Promotion }>()
);

export const loadPromotionFailure = createAction(
  '[Promotion] Load Promotion Failure',
  props<{ errorMessage: string }>()
);

// Load team promotions
export const loadTeamPromotions = createAction(
  '[Promotion] Load Promotions',
  props<{ teamId: string }>()
);

export const loadPromotionsSuccess = createAction(
  '[Promotion] Load Promotions Success',
  props<{ promotions: Promotion[] }>()
);

export const loadPromotionsFailure = createAction(
  '[Promotion] Load Promotions Failure',
  props<{ errorMessage: string }>()
);

// Handle creation of a promotion
export const updatePromotionToCreate = createAction(
  '[Promotion] Update Temporary Data For Promotion To Create',
  props<{ data: any }>()
);

export const addImageToPromotionToCreate = createAction(
  '[Promotion] Add Image To Promotion To Create',
  props<{ image: any[] }>()
);

export const addVideoToPromotionToCreate = createAction(
  '[Promotion] Add Video To Promotion To Create',
  props<{ video: any }>()
);

export const addVideoToPromotionToCreateSuccess = createAction(
  '[Promotion] Add Video To Promotion To Create Success',
  props<{ video: any }>()
);

export const addVideoToPromotionToCreateFailure = createAction(
  '[Promotion] Add Video To Promotion To Create Failure',
  props<{ errorMessage: string }>()
);

export const addImageToPromotionToCreateSuccess = createAction(
  '[Promotion] Add Image To Promotion To Create Success',
  props<{ image: any }>()
);

export const addImageToPromotionToCreateFailure = createAction(
  '[Promotion] Add Image To Promotion To Create Failure',
  props<{ errorMessage: string }>()
);

export const removeMediaFromPromotionToCreate = createAction(
  '[Promotion] Remove Media From Promotion To Create',
  props<{ media: any }>()
);

export const createPromotion = createAction(
  '[Promotion] Create Promotion',
);

export const createPromotionSuccess = createAction(
  '[Promotion] Create Promotion Success',
  props<{ promotion: any }>()
);

export const createPromotionFailure = createAction(
  '[Promotion] Create Promotion Failure',
  props<{ error: any }>()
);

export const cleanPromotionToCreate = createAction(
  '[Promotion] Clean Promotion To Create',
);

export const cleanPromotionToUpdate = createAction(
  '[Promotion] Clean Promotion To Update',
);

// Handle edit of a promotion
export const selectPromotionToUpdate = createAction(
  '[Promotion] Select Promotion To Udpate',
  props<{ promotion: any }>()
);

export const updatePromotionToUpdateTemp = createAction(
  '[Promotion] Update Promotion To Update Temp',
  props<{ data: any }>()
);

export const updatePromotion = createAction(
  '[Promotion] Update Promotion'
);

export const updatePromotionSuccess = createAction(
  '[Promotion] Update Promotion Success',
  props<{ promotion: any }>()
);

export const updatePromotionFailure = createAction(
  '[Promotion] Update Promotion Failure',
  props<{ error: any }>()
);

export const addImageToPromotionToUpdate = createAction(
  '[Promotion] Add Image To Promotion To Update',
  props<{ image: any[] }>()
);

export const addImageToPromotionToUpdateSuccess = createAction(
  '[Promotion] Add Image To Promotion To Update Success',
  props<{ image: any }>()
);

export const addImageToPromotionToUpdateFailure = createAction(
  '[Promotion] Add Image To Promotion To Update Failure',
  props<{ errorMessage: string }>()
);

export const addVideoToPromotionToUpdate = createAction(
  '[Promotion] Add Video To Promotion To Update',
  props<{ video: any }>()
);

export const addVideoToPromotionToUpdateSuccess = createAction(
  '[Promotion] Add Video To Promotion To Update Success',
  props<{ video: any }>()
);

export const addVideoToPromotionToUpdateFailure = createAction(
  '[Promotion] Add Video To Promotion To Update Failure',
  props<{ errorMessage: string }>()
);

export const removeMediaFromPromotionToUpdate = createAction(
  '[Promotion] Remove Media From Promotion To Update',
  props<{ media: any }>()
);

// Handle delete of a promotion
export const selectPromotionToDelete = createAction(
  '[Promotion] Select Promotion To Delete',
  props<{ promotion: any }>()
);

export const deletePromotion = createAction(
  '[Promotion] Delete Promotion'
);

export const deletePromotionSuccess = createAction(
  '[Promotion] Delete Promotion Success',
  props<{ promotion: any }>()
);

export const deletePromotionFailure = createAction(
  '[Promotion] Delete Promotion Failure',
  props<{ error: any }>()
);

